import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from '@shared/helper/local-repository';
import { TServiceResult } from '@shared/helper/t-service-result';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { Observable, catchError, of } from 'rxjs';
import { ChallengeAchievementModel, ChallengeByPerDay } from '../models/challenge-achievement-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { ChallengeStatisticModel } from '../models/challenge-statistic-model';
import { ChallengeChartModel } from '../models/challenge-chart-model';
import { ChallengeParticipantsModel } from '../models/challenge-participants-model';

@Injectable({
  providedIn: 'root'
})
export class ChallengeAchievementService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'chlg');
  }

  filterChallengesWithState(termFilter: TermFilterModel): Observable<TServiceResult<PageList<ChallengeAchievementModel>>> {
    return this.http.post<TServiceResult<PageList<ChallengeAchievementModel>>>(`${this.apiUrl}/actives/filterWithState`, termFilter);
  }

  getChallengeDetailById(id: string): Observable<TServiceResult<ChallengeAchievementModel>> {
    return this.http.get<TServiceResult<ChallengeAchievementModel>>(`${this.apiUrl}/idWithState/${id}`);
  }

  pickChallenge(id: string): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(`${this.apiUrl}/${id}/pick`, null);
  }

  discardChallenge(id: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.apiUrl}/${id}/discard`);
  }

  getChallengesByFilter(termFilter: TermFilterModel, state: number[], userId: string): Observable<TServiceResult<PageList<ChallengeAchievementModel>>> {
    const params = this.TermFilterParams(termFilter);
    let states = '';
    state.forEach(item => {
      states = states + '&' + 'states=' + `${item}`;
    })
    const filter = params + states;
    return this.http.get<TServiceResult<PageList<ChallengeAchievementModel>>>(`${this.apiUrl}/picked/${userId}${filter}`)
      .pipe(
        catchError(err => {
          return of(new TServiceResult<PageList<ChallengeAchievementModel>>(new PageList(), '', null, true, ''))
        })
      )
  }

  getMyChallengesStatistics(): Observable<TServiceResult<ChallengeStatisticModel>> {
    return this.http.get<TServiceResult<ChallengeStatisticModel>>(`${this.apiUrl}/GetMyChallengeStatistics`);
  }

  pickChallengeWithDetail(id: string): Observable<TServiceResult<ChallengeAchievementModel>> {
    return this.http.post<TServiceResult<ChallengeAchievementModel>>(`${this.apiUrl}/${id}/pickWithDetail`, null);
  }

  checkUserPickedChallenge(): Observable<TServiceResult<boolean>> {
    return this.http.get<TServiceResult<boolean>>(`${this.apiUrl}/CheckUserPickedChallenge`);
  }

  pickChallengeByDailyPageCount(DailyPageCount: number): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(`${this.apiUrl}/PickChallengeByDailyPageCount/${DailyPageCount}/ucId`, {});
  }

  reminderEnable(): Observable<TServiceResult<string>> {
    return this.http.patch<TServiceResult<string>>(`${this.apiUrl}/reminder/Enable`, null);
  }

  reminderDisable(): Observable<TServiceResult<string>> {
    return this.http.patch<TServiceResult<string>>(`${this.apiUrl}/reminder/Disable`, null);
  }

  getChallengeChartData(challengeId: string): Observable<TServiceResult<ChallengeChartModel>> {
    return this.http.get<TServiceResult<ChallengeChartModel>>(`${this.apiUrl}/chart/${challengeId}`);
  }

  currentChallengeParticipantsCount(ChallengeId: string): Observable<TServiceResult<ChallengeParticipantsModel>> {
    return this.http.get<TServiceResult<ChallengeParticipantsModel>>(`${this.apiUrl}/CurrentChallengeParticipantsCount/${ChallengeId}`);
  }

  byPagePerDay(challengePageCount: number, termFilter: TermFilterModel): Observable<TServiceResult<PageList<ChallengeByPerDay>>> {
    return this.http.post<TServiceResult<PageList<ChallengeByPerDay>>>(`${this.apiUrl}/ByPagePerDayCount/${challengePageCount}`, termFilter);
  }

}